// extracted by mini-css-extract-plugin
module.exports = {"component":"_3qK1t","banner":"Z6M8T","content":"O--pi","image":"_1o5Uv","header":"_2Fr8c","subheader":"_1pHfK","description":"_1tyaB","price":"lyCfi","button":"_2UzE1"};